import { render, staticRenderFns } from "./TableHierarchicalDocumentDelivery.vue?vue&type=template&id=2c5dfa7e&"
import script from "./TableHierarchicalDocumentDelivery.vue?vue&type=script&lang=js&"
export * from "./TableHierarchicalDocumentDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports